import { LanguageCircle } from "iconsax-react";
import { useTranslation } from "react-i18next";
import { Href, Language } from "../../../constants";
import { LanguagesData } from "../../../data/layout/Header";

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  return (
    <div className="login-flex onhover-dropdown">
      <a href={Href} className="login-icon">
        <LanguageCircle className="iconsax"/>
        <span>{Language}</span>
        <i className="ri-arrow-down-wide-line" />
      </a>
      <ul className="active-list onhover-list">
        {LanguagesData.map((item, index) => (
          <li className="active-item" key={index} onClick={() => i18n.changeLanguage(item.data)}>
            <a href={Href}>{item.language}</a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LanguageSelector;